import { editor } from '@/instance';
import { useStoreActions } from '@/store';

export const useMattingPluginHelper = () => {
    const setIsMatting = useStoreActions((actions) => actions.pluginModel.setIsMatting);
    const setIsShowPanel = useStoreActions((actions) => actions.editorModel.setIsShowPanel);
    const setIsShowCollapse = useStoreActions((actions) => actions.editorModel.setIsShowCollapse);
    const clearProcessingMattingImgInfo = useStoreActions(
        (actions) => actions.pluginModel.clearProcessingMattingImgInfo,
    );
    const setIsMattingMainLayer = useStoreActions((actions) => actions.pluginModel.setIsMattingMainLayer);
    const setIsDisable = useStoreActions((actions) => actions.editorModel.setIsDisable);

    // 打开
    const show = (isMainLayer?: boolean) => {
        setIsMatting(true);
        setIsMattingMainLayer(!!isMainLayer);
        setIsDisable(true);
        setIsShowPanel(false);
        setIsShowCollapse(false);
        editor.disableOperate();
    };

    // 关闭
    const close = () => {
        setIsDisable(false);
        setIsShowPanel(true);
        setIsShowCollapse(true);
        editor.enableOperate();
        clearProcessingMattingImgInfo();
        setIsMattingMainLayer(false);
        setIsMatting(false);
    };

    return {
        show,
        close,
    };
};
